import { useTranslation } from 'react-i18next'
import { Icon, IconButton } from '@ds'
import { CardInfo, getCDNUrl, LAST_SPIRAL_BORDER_DEF_IDS, PANELKA_HINT_KEY_ITEM_ID, TAPLAPSE_BOOSTER } from '@shared'
import { REFILLS_QUANTITY, InventoryCard, SKINS_TYPES, useUserBankTaps } from '@store'
import styles from './ModalContent.module.scss'
import { useEffect, useMemo, useState } from 'react'

const SOON_CARD = ['019b3d56-be10-722c-983f-151cbd275af1']

type Props = {
  card: InventoryCard | null
  state: 'preview' | 'use'
  onClose: () => void
  onClick?: () => void
  showUseButton?: boolean
}

export const ModalContent = ({
  card,
  state,
  onClose,
  onClick,
  showUseButton = true,
}: Props) => {
  const [disableAction, setDisableAction] = useState(false)
  const taps = useUserBankTaps()
  const { t } = useTranslation()
  useEffect(() => {
    if (card && taps) {
      const tapsBooster = REFILLS_QUANTITY[card.itemDefId];
      if (tapsBooster && (taps.balance >= taps.limit)) {
        setDisableAction(true)
      }

      if (TAPLAPSE_BOOSTER === card.itemDefId){
        setDisableAction(new Date() < new Date(taps.taplapsTime))
      }
    }
  }, [card, taps])

  const isSoonCard = card?.id && SOON_CARD.includes(card.id)

  const handleIconButtonClick = () => {
    if (isSoonCard) {
      return
    }
    onClick?.()
  }

  const cardInfo = useMemo(() => {
    if (!card) {
      return {
        url: '',
        effects: {
          mask: false,
          moveDown: false,
          invertAnimation: false,
          fullFilling: false
        },
      }
    }
    const url = card.appFiles ? getCDNUrl(card.appFiles) : card.iconUrl ? getCDNUrl(card.iconUrl) : '';
    const fullFillingHint = card.itemDefId === PANELKA_HINT_KEY_ITEM_ID;
    return {
      url: url,
      effects: {
        cardUrl: card.collection?.includes('Glyph') ? getCDNUrl(card.iconUrl) : undefined,
        mask: card.displayType === 'avatar' || card.displayType === 'card',
        moveDown: Boolean(REFILLS_QUANTITY[card.itemDefId || ''] && REFILLS_QUANTITY[card.itemDefId || ''] < 10),
        fullFilling: fullFillingHint,
        skipRarityTag: LAST_SPIRAL_BORDER_DEF_IDS.includes(card.itemDefId), 
        diamondColor: LAST_SPIRAL_BORDER_DEF_IDS.includes(card.itemDefId) ? "rgba(115, 0, 255, 1)" : undefined
      },
      title: fullFillingHint ? '' : card.title,
      description: card.description,
      rarity: (card.displayType && SKINS_TYPES.includes(card.displayType)) || LAST_SPIRAL_BORDER_DEF_IDS.includes(card.itemDefId) ? card.rarity : undefined,
    }
  }, [card])

  const callToActionButtonName = useMemo(() => {
    if (isSoonCard) {
      return 'Soon'
    }
    if (card?.displayType && SKINS_TYPES.includes(card.displayType)) {
      return t('shared.inventory.equip')
    }
    return t('shared.inventory.use')
  }, [isSoonCard, card?.displayType])
  return (
    <CardInfo 
      url={cardInfo.url} 
      rarity={cardInfo.rarity}
      effects={cardInfo.effects} 
      onClose={onClose} 
      title={cardInfo.title} 
      description={cardInfo.description} 
    >
      {card?.type === 'booster' && state === 'use' && showUseButton && !disableAction ? (
        <IconButton
          leftIcon={<Icon name="bow" size="M" />}
          onClick={handleIconButtonClick}
          className={styles.button}
        >
          <span className={styles.buttonText}>
            {callToActionButtonName}
          </span>
        </IconButton>
      ) : null}
      {state === 'preview' ? (
        <IconButton onClick={onClose} className={styles.button}>
          <span className={styles.buttonText}>
            {t('shared.inventory.accept')}
          </span>
        </IconButton>
      ) : null}
    </CardInfo>
  )
}
